import { render } from "./TvmNewVehicle.vue?vue&type=template&id=4f3798ae&scoped=true"
import script from "./TvmNewVehicle.vue?vue&type=script&lang=js"
export * from "./TvmNewVehicle.vue?vue&type=script&lang=js"

import "./TvmNewVehicle.vue?vue&type=style&index=0&id=4f3798ae&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3798ae"]])

export default __exports__